export default __webpack_public_path__ + "static/test_2_5_ru-7276ae2096c2b110cd07e11befd86b40.png";